export default {
  getBaseUrl (state) {
    return state.baseUrl
  },
  getImageUrl (state) {
    return state.imagesUrl
  },
  getStates (state) {
    return state.states
  },
  getValidationErrors (state) {
    return state.validationErrors
  },
  getOverlay (state) {
    return state.overlay
  },
  getHeader (state) {
    return state.header
  },
  getFooter (state) {
    return state.footer
  },
  getStripePk (state) {
    return state.stripePk
  },
  getSubscriptionStatus (state) {
    return state.subscriptionStatus
  }
}
